// import { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { useFetchOne } from '../../hooks/useFetch';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import Loading from '../../components/common/Loading';
// import ErrorMessage from '../../components/common/ErrorMessage';
// import ReactMarkdown from 'react-markdown';
// import SocialShares from '../../components/common/Socials/SocialShares';
// import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';


// const PostDetail = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.POSTS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);

//     const [images, setImages] = useState([]);
//     const [selectedImageIndex, setSelectedImageIndex] = useState(null);
//     const [dragStart, setDragStart] = useState(null);
//     const [dragEnd, setDragEnd] = useState(null);
//     const [isDragging, setIsDragging] = useState(false);

//     // Minimum swipe distance (in px)
//     const minSwipeDistance = 50;

//     // Extract images from markdown content
//     useEffect(() => {
//         if (post?.description) {
//             const imgRegex = /!\[.*?\]\((.*?)\)/g;
//             const extractedImages = [];
//             let match;

//             while ((match = imgRegex.exec(post.description)) !== null) {
//                 extractedImages.push(match[1]);
//             }

//             setImages(extractedImages);
//         }
//     }, [post]);

//     // Handle keyboard navigation
//     useEffect(() => {
//         const handleKeyboard = (e) => {
//             if (selectedImageIndex === null) return;

//             if (e.key === 'Escape') {
//                 setSelectedImageIndex(null);
//             } else if (e.key === 'ArrowLeft') {
//                 goToPrevious();
//             } else if (e.key === 'ArrowRight') {
//                 goToNext();
//             }
//         };

//         document.addEventListener('keydown', handleKeyboard);
//         return () => document.removeEventListener('keydown', handleKeyboard);
//     }, [selectedImageIndex, images.length]);

//     const goToNext = () => {
//         if (selectedImageIndex === null) return;
//         setSelectedImageIndex((prev) => (prev + 1) % images.length);
//     };

//     const goToPrevious = () => {
//         if (selectedImageIndex === null) return;
//         setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length);
//     };

//     const onMouseDown = (e) => {
//         setDragEnd(null);
//         setDragStart(e.clientX);
//         setIsDragging(true);
//     };

//     const onMouseMove = (e) => {
//         if (!isDragging) return;
//         setDragEnd(e.clientX);
//     };

//     const onMouseUp = () => {
//         if (!isDragging || !dragStart || !dragEnd) {
//             setIsDragging(false);
//             return;
//         }

//         const distance = dragStart - dragEnd;
//         const isLeftSwipe = distance > minSwipeDistance;
//         const isRightSwipe = distance < -minSwipeDistance;

//         if (isLeftSwipe) {
//             goToNext();
//         } else if (isRightSwipe) {
//             goToPrevious();
//         }

//         setIsDragging(false);
//     };

//     const onMouseLeave = () => {
//         setIsDragging(false);
//     };

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;
//     if (!post) {
//         return (
//             <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//                 <ErrorMessage message="İçerik bulunamadı" />
//                 <div className="text-center mt-8">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
//                     >
//                         ← Geri Dön
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const imageUrl = getMediaURL(post.image);

//     // Render images in grid if there are multiple
//     const renderImages = () => {
//         if (images.length === 0) return null;

//         return (
//             <div className="my-8">
//                 <div className="grid grid-cols-2 gap-4">
//                     {images.map((img, index) => (
//                         <div
//                             key={index}
//                             className="aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow cursor-pointer"
//                             onClick={() => setSelectedImageIndex(index)}
//                         >
//                             <img
//                                 src={img}
//                                 alt={`Gallery image ${index + 1}`}
//                                 className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
//                             />
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     };

//     // Remove images from markdown content for separate display
//     const contentWithoutImages = post.description?.replace(/!\[.*?\]\(.*?\)/g, '') || '';

//     return (
//         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-2 lg:py-8">
//             {/* Breadcrumb */}
//             <nav className="mb-4 text-sm text-gray-600">
//                 <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <Link to={`/${URL_ENDPOINTS.POSTS}`} className="text-blue-900 hover:underline">Haberler</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <span className="text-gray-800">{post.title}</span>
//             </nav>

//             {/* Back Button */}
//             <button
//                 onClick={() => navigate(-1)}
//                 className="inline-block mb-4 px-4 py-2 text-blue-900 font-medium rounded hover:bg-gray-100 transition-colors"
//             >
//                 ← Geri Dön
//             </button>

//             <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-blue-900 mb-6 leading-tight">
//                 {post.title}
//             </h1>

//             {/* Meta Information */}
//             <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-8 pb-4 border-b-2 border-gray-100">
//                 {post.publishedAt && (
//                     <span className="text-sm sm:text-base text-gray-600">
//                         Yayınlama tarihi: {formatDate(post.publishedAt)}
//                     </span>
//                 )}
//             </div>

//             {/* Article */}
//             <article className="bg-white rounded-lg shadow-md overflow-hidden">
//                 {/* Featured Image */}
//                 {imageUrl && (
//                     <div className="w-full max-h-96 sm:max-h-[500px] overflow-hidden">
//                         <img
//                             src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                             alt={post.title}
//                             className="w-full h-auto object-cover"
//                         />
//                     </div>
//                 )}

//                 {/* Content */}
//                 <div className="p-6 sm:p-8 lg:p-10">
//                     {/* Description with Markdown (without images) */}
//                     <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
//                         <ReactMarkdown
//                             components={{
//                                 img: () => null,
//                                 p: ({ node, ...props }) => (
//                                     <p {...props} className="mb-4" />
//                                 ),
//                                 h1: ({ node, ...props }) => (
//                                     <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
//                                 ),
//                                 h2: ({ node, ...props }) => (
//                                     <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
//                                 ),
//                                 h3: ({ node, ...props }) => (
//                                     <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
//                                 ),
//                                 ul: ({ node, ...props }) => (
//                                     <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
//                                 ),
//                                 ol: ({ node, ...props }) => (
//                                     <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
//                                 ),
//                                 a: ({ node, ...props }) => (
//                                     <a {...props} className="text-blue-900 hover:underline" />
//                                 ),
//                             }}
//                         >
//                             {contentWithoutImages}
//                         </ReactMarkdown>
//                     </div>

//                     {/* Image Gallery Grid */}
//                     {renderImages()}

//                     {/* Full Content */}
//                     {post.content && (
//                         <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
//                             <p>{post.content}</p>
//                         </div>
//                     )}

//                     {/* Action Buttons */}
//                     <div className="flex flex-col sm:flex-row gap-4 mt-12 pt-8 border-t border-gray-200">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
//                         >
//                             ← Geri Dön
//                         </button>
//                     </div>
//                 </div>
//             </article>

//             <SocialShares />

//             {/* Swipeable Lightbox Modal */}
//             {selectedImageIndex !== null && (
//                 <div
//                     className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-sm"
//                     onClick={() => setSelectedImageIndex(null)}
//                 >
//                     <div
//                         className="relative w-full h-full max-w-7xl flex items-center justify-center"
//                         onMouseDown={onMouseDown}
//                         onMouseMove={onMouseMove}
//                         onMouseUp={onMouseUp}
//                         onMouseLeave={onMouseLeave}
//                         onClick={(e) => e.stopPropagation()}
//                         style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
//                     >
//                         {/* Close Button */}
//                         <button
//                             onClick={() => setSelectedImageIndex(null)}
//                             className="absolute top-4 right-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-3xl font-bold hover:text-gray-200 transition-all"
//                             aria-label="Close"
//                         >
//                             ×
//                         </button>

//                         {/* Image Counter */}
//                         <div className="absolute top-4 left-4 z-50 px-4 py-2 bg-black bg-opacity-50 rounded-full text-white text-sm font-medium">
//                             {selectedImageIndex + 1} / {images.length}
//                         </div>

//                         {/* Previous Button */}
//                         {images.length > 1 && (
//                             <button
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     goToPrevious();
//                                 }}
//                                 className="absolute left-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-2xl font-bold hover:text-gray-200 transition-all"
//                                 aria-label="Previous"
//                             >
//                                 ‹
//                             </button>
//                         )}

//                         {/* Image */}
//                         <img
//                             src={images[selectedImageIndex]}
//                             alt={`Gallery image ${selectedImageIndex + 1}`}
//                             className="max-w-full max-h-screen object-contain rounded-lg shadow-2xl px-16"
//                             style={{ userSelect: 'none', pointerEvents: 'none' }}
//                         />

//                         {/* Next Button */}
//                         {images.length > 1 && (
//                             <button
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     goToNext();
//                                 }}
//                                 className="absolute right-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-2xl font-bold hover:text-gray-200 transition-all"
//                                 aria-label="Next"
//                             >
//                                 ›
//                             </button>
//                         )}

//                         {/* Pagination Dots */}
//                         {images.length > 1 && (
//                             <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
//                                 {images.map((_, index) => (
//                                     <button
//                                         key={index}
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             setSelectedImageIndex(index);
//                                         }}
//                                         className={`w-2 h-2 rounded-full transition-all ${index === selectedImageIndex
//                                             ? 'bg-white w-8'
//                                             : 'bg-white bg-opacity-50 hover:bg-opacity-75'
//                                             }`}
//                                         aria-label={`Go to image ${index + 1}`}
//                                     />
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default PostDetail;


import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useFetchOne } from '../../hooks/useFetch';
import { getMediaURL, formatDate, getEmbedUrl } from '../../utils/helpers';
import Loading from '../../components/common/Loading';
import ErrorMessage from '../../components/common/ErrorMessage';
import ReactMarkdown from 'react-markdown';
import SocialShares from '../../components/common/Socials/SocialShares';
import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';
import { toTurkishDate } from '../../utils/dateConvertToTr'


const PostDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.POSTS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);

    const [images, setImages] = useState([]);
    const [youtubeVideos, setYoutubeVideos] = useState([]);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [dragStart, setDragStart] = useState(null);
    const [dragEnd, setDragEnd] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    // Minimum swipe distance (in px)
    const minSwipeDistance = 50;

    // Extract images and YouTube videos from markdown content
    useEffect(() => {
        if (post?.description) {
            const imgRegex = /!\[.*?\]\((.*?)\)/g;
            const extractedImages = [];
            let match;

            while ((match = imgRegex.exec(post.description)) !== null) {
                extractedImages.push(match[1]);
            }

            setImages(extractedImages);

            // Extract YouTube links (both in markdown links and plain URLs)
            const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/g;
            const extractedVideos = [];
            let videoMatch;

            while ((videoMatch = youtubeRegex.exec(post.description)) !== null) {
                extractedVideos.push(videoMatch[0]);
            }

            setYoutubeVideos(extractedVideos);
        }
    }, [post]);

    // Handle keyboard navigation
    useEffect(() => {
        const handleKeyboard = (e) => {
            if (selectedImageIndex === null) return;

            if (e.key === 'Escape') {
                setSelectedImageIndex(null);
            } else if (e.key === 'ArrowLeft') {
                goToPrevious();
            } else if (e.key === 'ArrowRight') {
                goToNext();
            }
        };

        document.addEventListener('keydown', handleKeyboard);
        return () => document.removeEventListener('keydown', handleKeyboard);
    }, [selectedImageIndex, images.length]);

    const goToNext = () => {
        if (selectedImageIndex === null) return;
        setSelectedImageIndex((prev) => (prev + 1) % images.length);
    };

    const goToPrevious = () => {
        if (selectedImageIndex === null) return;
        setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const onMouseDown = (e) => {
        setDragEnd(null);
        setDragStart(e.clientX);
        setIsDragging(true);
    };

    const onMouseMove = (e) => {
        if (!isDragging) return;
        setDragEnd(e.clientX);
    };

    const onMouseUp = () => {
        if (!isDragging || !dragStart || !dragEnd) {
            setIsDragging(false);
            return;
        }

        const distance = dragStart - dragEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            goToNext();
        } else if (isRightSwipe) {
            goToPrevious();
        }

        setIsDragging(false);
    };

    const onMouseLeave = () => {
        setIsDragging(false);
    };

    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;
    if (!post) {
        return (
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <ErrorMessage message="İçerik bulunamadı" />
                <div className="text-center mt-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
                    >
                        ← Geri Dön
                    </button>
                </div>
            </div>
        );
    }

    // const imageUrl = getMediaURL(post.image);
    const imageUrl = post?.image
        ? getMediaURL(post.image)
        : '/placeholder_hor.jpg';

    // Render images in grid if there are multiple
    const renderImages = () => {
        if (images.length === 0) return null;

        return (
            <div className="my-8">
                <div className="grid grid-cols-2 gap-4">
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow cursor-pointer"
                            onClick={() => setSelectedImageIndex(index)}
                        >
                            <img
                                src={img}
                                alt={`Gallery image ${index + 1}`}
                                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // Render YouTube videos
    const renderYouTubeVideos = () => {
        if (youtubeVideos.length === 0) return null;

        return (
            <div className="my-8 space-y-6">
                {youtubeVideos.map((videoUrl, index) => (
                    <div key={index} className="w-full">
                        <div className="relative w-full pb-[56.25%] rounded-lg overflow-hidden shadow-lg">
                            <iframe
                                src={getEmbedUrl(videoUrl)}
                                title={`YouTube video ${index + 1}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="absolute top-0 left-0 w-full h-full"
                            ></iframe>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Remove images and YouTube links from markdown content for separate display
    const contentWithoutImagesAndVideos = post.description
        ?.replace(/!\[.*?\]\(.*?\)/g, '') // Remove images
        ?.replace(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/g, '') // Remove YouTube links
        || '';

    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-2 lg:py-8">
            {/* Breadcrumb */}
            <nav className="mb-4 text-sm text-gray-600">
                <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
                <span className="mx-2 text-gray-400">/</span>
                <Link to={`/${URL_ENDPOINTS.POSTS}`} className="text-blue-900 hover:underline">Duyurular & Haberler</Link>
                <span className="mx-2 text-gray-400">/</span>
                <span className="text-gray-800">{post.title}</span>
            </nav>

            {/* Back Button */}
            <button
                onClick={() => navigate(-1)}
                className="inline-block mb-4 px-4 py-2 text-blue-900 font-medium rounded hover:bg-gray-100 transition-colors"
            >
                ← Geri Dön
            </button>

            <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-blue-900 mb-6 leading-tight">
                {post.title}
            </h1>

            {/* Meta Information */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-8 pb-4 border-b-2 border-gray-100">
                {post.publishedAt && (
                    <span className="text-sm sm:text-base text-gray-600">
                        Yayınlama tarihi: {toTurkishDate(post.publishedAt)}
                    </span>
                )}
            </div>

            {/* Article */}
            <article className="bg-white rounded-lg shadow-md overflow-hidden">
                {/* Featured Image */}
                {imageUrl && (
                    <div className="w-full max-h-96 sm:max-h-[500px] overflow-hidden">
                        <img
                            src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
                            alt={post.title}
                            className="w-full h-auto object-cover"
                        />
                    </div>
                )}

                {/* Content */}
                <div className="p-6 sm:p-8 lg:p-10">
                    {/* Description with Markdown (without images and videos) */}
                    <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
                        <ReactMarkdown
                            components={{
                                img: () => null,
                                p: ({ node, ...props }) => (
                                    <p {...props} className="mb-4" />
                                ),
                                h1: ({ node, ...props }) => (
                                    <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
                                ),
                                h2: ({ node, ...props }) => (
                                    <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
                                ),
                                h3: ({ node, ...props }) => (
                                    <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
                                ),
                                ul: ({ node, ...props }) => (
                                    <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
                                ),
                                ol: ({ node, ...props }) => (
                                    <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
                                ),
                                a: ({ node, ...props }) => (
                                    <a {...props} className="text-blue-900 hover:underline" />
                                ),
                            }}
                        >
                            {contentWithoutImagesAndVideos}
                        </ReactMarkdown>
                    </div>

                    {/* YouTube Videos */}
                    {renderYouTubeVideos()}

                    {/* Image Gallery Grid */}
                    {renderImages()}

                    {/* Full Content */}
                    {post.content && (
                        <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
                            <p>{post.content}</p>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-12 pt-8 border-t border-gray-200">
                        <button
                            onClick={() => navigate(-1)}
                            className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
                        >
                            ← Geri Dön
                        </button>
                    </div>
                </div>
            </article>

            <SocialShares />

            {/* Swipeable Lightbox Modal */}
            {selectedImageIndex !== null && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-sm"
                    onClick={() => setSelectedImageIndex(null)}
                >
                    <div
                        className="relative w-full h-full max-w-7xl flex items-center justify-center"
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseUp={onMouseUp}
                        onMouseLeave={onMouseLeave}
                        onClick={(e) => e.stopPropagation()}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setSelectedImageIndex(null)}
                            className="absolute top-4 right-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-3xl font-bold hover:text-gray-200 transition-all"
                            aria-label="Close"
                        >
                            ×
                        </button>

                        {/* Image Counter */}
                        <div className="absolute top-4 left-4 z-50 px-4 py-2 bg-black bg-opacity-50 rounded-full text-white text-sm font-medium">
                            {selectedImageIndex + 1} / {images.length}
                        </div>

                        {/* Previous Button */}
                        {images.length > 1 && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    goToPrevious();
                                }}
                                className="absolute left-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-2xl font-bold hover:text-gray-200 transition-all"
                                aria-label="Previous"
                            >
                                ‹
                            </button>
                        )}

                        {/* Image */}
                        <img
                            src={images[selectedImageIndex]}
                            alt={`Gallery image ${selectedImageIndex + 1}`}
                            className="max-w-full max-h-screen object-contain rounded-lg shadow-2xl px-16"
                            style={{ userSelect: 'none', pointerEvents: 'none' }}
                        />

                        {/* Next Button */}
                        {images.length > 1 && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    goToNext();
                                }}
                                className="absolute right-4 z-50 w-12 h-12 flex items-center justify-center bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white text-2xl font-bold hover:text-gray-200 transition-all"
                                aria-label="Next"
                            >
                                ›
                            </button>
                        )}

                        {/* Pagination Dots */}
                        {images.length > 1 && (
                            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
                                {images.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedImageIndex(index);
                                        }}
                                        className={`w-2 h-2 rounded-full transition-all ${index === selectedImageIndex
                                            ? 'bg-white w-8'
                                            : 'bg-white bg-opacity-50 hover:bg-opacity-75'
                                            }`}
                                        aria-label={`Go to image ${index + 1}`}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PostDetail;